import React, { useEffect } from "react";
import Msbanner from "./Msbanner";
import Msabout from "./Msabout";
import Msfeatures from "./Msfeatures";
import Mscards from "./Mscards";
import Webbanner from "./Webbanner";

const Ms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Msbanner/>
      
      <Msabout/>

      <Msfeatures/>
      <Mscards/>
    </div>
  );
};

export default Ms;